const PREORDER_STEPS = {
  SELECT_SUPPLIER: 1,
  SELECT_TARGET: 2,
  PREORDER_STARTED: 3,
}

export { PREORDER_STEPS }